import {
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BFormInvalidFeedback,
  BModal,
} from "bootstrap-vue";

import {
  ACTION_TYPES,
  attachLevel,
  buildActionFormData,
  buildSuccessMessage,
  createEmptyAction,
  extractSavedAction,
  formatAmount,
  mapServerErrors,
  normalizeAction,
  parseAmount,
  validateAction,
} from "./ActionFormUtils";

const MODAL_ID = "action-modal";

export default {
  name: "ActionForm",

  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormInvalidFeedback,
  },

  props: {
    mainData: {
      type: Object,
      default: () => createEmptyAction(),
    },
    mode: {
      type: String,
      default: "create",
    },
    url: {
      type: String,
      required: true,
    },
    levels: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      action: normalizeAction(this.mainData),
      disabled: false,
      errors: {},
    };
  },

  computed: {
    levelOptions() {
      return this.levels.map((level) => ({
        value: level.id,
        text:
          level.title ||
          level.name ||
          level.label ||
          level.display_name ||
          `سطح ${level.id}`,
      }));
    },

    isFreeShipping() {
      return this.action.type === ACTION_TYPES.FREE_SHIPPING;
    },

    isWalletCharge() {
      return this.action.type === ACTION_TYPES.WALLET_CHARGE;
    },

    // مقدار نمایشی type_value با جداکننده سه‌رقمی (مدل همیشه عدد خام می‌ماند)
    typeValueDisplay: {
      get() {
        return formatAmount(this.action.type_value);
      },
      set(value) {
        const amount = parseAmount(value);

        this.action.type_value = amount === null ? "" : amount;
        this.clearFieldError("type_value");
      },
    },
  },

  watch: {
    mainData: {
      deep: true,
      handler(value) {
        this.action = normalizeAction(value);
        this.errors = {};
      },
    },
  },

  methods: {
    // برای :formatter در تمپلیت
    formatAmount,

    fieldState(field) {
      return this.errors[field] ? false : null;
    },

    clearFieldError(field) {
      if (this.errors[field]) {
        this.$delete(this.errors, field);
      }
    },

    // معنی type_value با نوع عملیات عوض می‌شود، پس هنگام تغییر نوع پاک می‌شود
    handleTypeChange() {
      this.clearFieldError("type");
      this.clearFieldError("type_value");
      this.action.type_value = "";
    },

    validateForm() {
      this.errors = validateAction(this.action);

      return Object.keys(this.errors).length === 0;
    },

    applyServerErrors(error) {
      this.errors = { ...this.errors, ...mapServerErrors(error) };
    },

    async submit(event) {
      if (event && typeof event.preventDefault === "function") {
        event.preventDefault();
      }

      if (this.disabled || !this.validateForm()) {
        return;
      }

      this.disabled = true;

      try {
        const response = await this.$axios.post(
          this.url,
          buildActionFormData(this.action, this.mode)
        );
        const savedAction = attachLevel(
          this.action,
          extractSavedAction(response),
          this.levels
        );

        this.$root.notify(buildSuccessMessage(response, this.mode), "success");
        this.$emit("saved", savedAction, this.mode, this.action.index);
        this.$root.$emit("bv::hide::modal", MODAL_ID);
      } catch (error) {
        this.applyServerErrors(error);
        this.$root.notify(error);
      } finally {
        this.disabled = false;
      }
    },

    onHidden() {
      this.errors = {};
      this.disabled = false;
    },
  },
};